import Pusher from 'pusher-js'

// Single shared Pusher connection for the todo app. No-ops if no key is set,
// so the app works fine before Pusher is configured.
let pusher = null
let channel = null

export function initRealtime(officeId) {
  const key = process.env.VUE_APP_PUSHER_KEY
  const cluster = process.env.VUE_APP_PUSHER_CLUSTER || 'eu'
  if (!key || !officeId || pusher) return
  try {
    pusher = new Pusher(key, { cluster, forceTLS: true })
    channel = pusher.subscribe(`todo-office-${officeId}`)
  } catch (e) {
    pusher = null
    channel = null
  }
}

/** Bind a handler to a realtime event. Returns an unsubscribe function. */
export function onRealtime(event, handler) {
  if (!channel) return () => {}
  channel.bind(event, handler)
  return () => { try { channel.unbind(event, handler) } catch (e) {} }
}

export function teardownRealtime() {
  try { if (pusher) pusher.disconnect() } catch (e) {}
  pusher = null
  channel = null
}

/** Small debounce so a burst of events triggers one refetch. */
export function debounce(fn, ms = 400) {
  let t
  return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms) }
}
